// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"c648e4ef","618":"17337164"}[chunkId] + ".chunk.js";
};